import { render, staticRenderFns } from "./medInsituteSearch.vue?vue&type=template&id=448b6b0c&scoped=true&"
import script from "./medInsituteSearch.vue?vue&type=script&lang=js&"
export * from "./medInsituteSearch.vue?vue&type=script&lang=js&"
import style0 from "./medInsituteSearch.vue?vue&type=style&index=0&id=448b6b0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448b6b0c",
  null
  
)

export default component.exports